module.exports = __webpack_public_path__ + "static/media/podcast.7252432a.svg";